export const islandStates = [
    'Baker Island',
    'Howland Island',
    'Jarvis Island',
    'Navassa Island',
    'Northern Mariana Islands',
    'Rhode Island',
    'United States Minor Outlying Islands',
    'Rhode Island',
    'United States Minor Outlying Islands',
    'United States Virgin Islands',
];
export const mergeFields = [
    {
        name: 'Membership Type',
        value: '{{MEMBERSHIP_TYPE}}',
    },
    {
        name: 'Membership Name',
        value: '{{MEMBERSHIP_NAME}}',
    },
    {
        name: 'Services',
        value: '{{SERVICES}}',
    },
    {
        name: 'Assessed Fees',
        value: '{{ASSESSED_FEES}}',
    },

    {
        name: 'Client’s Title',
        value: '{{MEMBER_TITLE}}',
    },
    {
        name: 'Client’s First Name',
        value: '{{MEMBER_FIRST_NAME}}',
    },
    {
        name: 'Client’s Last Name',
        value: '{{MEMBER_LAST_NAME}}',
    },
    {
        name: 'Client’s Barcode',
        value: '{{MEMBER_BARCODE}}',
    },
    {
        name: 'Client’s Address',
        value: '{{MEMBER_ADDRESS}}',
    },
    {
        name: 'Client’s City',
        value: '{{MEMBER_CITY}}',
    },
    {
        name: 'Client’s State',
        value: '{{MEMBER_STATE}}',
    },

    {
        name: 'Client’s Zip Code',
        value: '{{MEMBER_ZIPCODE}}',
    },
    {
        name: 'Client’s Country or Region',
        value: '{{MEMBER_COUNTRY}}',
    },
    {
        name: 'Client’s Phone',
        value: '{{MEMBER_PHONE}}',
    },
    {
        name: 'Client’s Email',
        value: '{{MEMBER_EMAIL}}',
    },
    {
        name: 'Client’s Cell Phone',
        value: '{{MEMBER_CELL_PHONE}}',
    },
    {
        name: 'Client’s Govt. ID',
        value: '{{MEMBER_GOVT_ID}}',
    },
    {
        name: 'Employer',
        value: '{{MEMBER_EMPLOYER}}',
    },
    {
        name: 'Work Phone',
        value: '{{MEMBER_WORK_PHONE}}',
    },
    {
        name: 'Emergency Contact Name',
        value: '{{MEMBER_EMERGENCY_CONTACT_NAME}}',
    },
    {
        name: 'Emergency Contact Number',
        value: '{{MEMBER_EMERGENCY_CONTACT_NUMBER}}',
    },

    //COMPANY
    {
        name: 'Company Name',
        value: '{{COMPANY_NAME}}',
    },
    {
        name: 'Company Address',
        value: '{{COMPANY_ADDRESS}}',
    },
    {
        name: 'Company City',
        value: '{{COMPANY_CITY}}',
    },
    {
        name: 'Company State',
        value: '{{COMPANY_STATE}}',
    },
    {
        name: 'Company Zip Code',
        value: '{{COMPANY_ZIPCODE}}',
    },

    {
        name: 'Company Country or Region',
        value: '{{COMPANY_COUNTRY}}',
    },

    {
        name: 'Company Phone',
        value: '{{COMPANY_PHONE}}',
    },
    {
        name: 'Company Email',
        value: '{{COMPANY_EMAIL}}',
    },
    //
    {
        name: 'Salesperson',
        value: '{{SALES_PERSON}}',
    },
    {
        name: 'Campaign',
        value: '{{CAMPAIGN}}',
    },

    //Membership Agreement
    {
        name: 'Agreement #',
        value: '{{AGREEMENT_NUMBER}}',
    },
    {
        name: '⁠Membership Begin Date',
        value: '{{MEMBERSHIP_BEGIN_DATE}}',
    },
    {
        name: 'First Month Dues',
        value: '{{FIRST_MONTH_DUES}}',
    },
    {
        name: 'Billing Date',
        value: '{{BILLING_DATE}}',
    },
    {
        name: 'Billing Frequency',
        value: '{{BILLING_FREQUENCY}}',
    },
    {
        name: 'Renewal Type',
        value: '{{RENEWAL_TYPE}}',
    },
    {
        name: 'Renewal Date',
        value: '{{RENEWAL_DATE}}',
    },
    {
        name: '⁠Payment Method',
        value: '{{PAYMENT_METHOD}}',
    },
    {
        name: '⁠Past Due Balance',
        value: '{{PAST_DUE_BALANCE}}',
    },
    {
        name: '⁠Total Amount Due',
        value: '{{TOTAL_AMOUNT_DUE}}',
    },
    {
        name: 'Date',
        value: '{{DATE}}',
    },
    {
        name: 'Time',
        value: '{{TIME}}',
    },
];
export const filterType = [
    { name: 'Any of these', value: 'OR' },
    { name: 'All of these', value: 'AND' },
];
